import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeople = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6189 14.1333C15.0356 14.1333 16.1841 12.9842 16.1841 11.5667C16.1841 10.1491 15.0356 9 13.6189 9C12.2021 9 11.0536 10.1491 11.0536 11.5667C11.0536 12.9842 12.2021 14.1333 13.6189 14.1333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 18.185C11.9973 16.1867 15.2405 16.1867 17.2469 18.185",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6189 26.9392C15.0356 26.9392 16.1841 25.7901 16.1841 24.3726C16.1841 22.955 15.0356 21.8059 13.6189 21.8059C12.2021 21.8059 11.0536 22.955 11.0536 24.3726C11.0536 25.7901 12.2021 26.9392 13.6189 26.9392Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 31C11.9973 29.0016 15.2405 29.0016 17.2469 31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3811 14.1333C27.7979 14.1333 28.9464 12.9842 28.9464 11.5667C28.9464 10.1491 27.7979 9 26.3811 9C24.9644 9 23.8159 10.1491 23.8159 11.5667C23.8159 12.9842 24.9644 14.1333 26.3811 14.1333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7531 18.185C24.7503 16.1867 27.9935 16.1867 30 18.185",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3811 26.9392C27.7979 26.9392 28.9464 25.7901 28.9464 24.3726C28.9464 22.955 27.7979 21.8059 26.3811 21.8059C24.9644 21.8059 23.8159 22.955 23.8159 24.3726C23.8159 25.7901 24.9644 26.9392 26.3811 26.9392Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7531 31C24.7503 29.0016 27.9935 29.0016 30 31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgPeople);
export default ForwardRef;
